import { render, staticRenderFns } from "./CardDrag.vue?vue&type=template&id=797496e6&"
import script from "./CardDrag.vue?vue&type=script&lang=js&"
export * from "./CardDrag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports